export default "/images/avatar-default.png?a0c5a6d76c99c4b6353f158dc224e281";